import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, ERROR_TEXT, SUCCESS_TEXT } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Brand, ThemeToggle } from "@/components/hm/Basics";
import { SiteFooter } from "@/components/hm/SiteFooter";

const Box = ({ id, children }) => (
  <div className="paywall hm-fade-up" style={{ marginTop: "2rem" }} data-testid={id}>{children}</div>
);

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const { refresh } = useAuth();
  const [state, setState] = useState("checking");

  useEffect(() => {
    const sid = params.get("session_id");
    if (!sid) return setState("error");
    let tries = 0, timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") { await refresh(); return setState("paid"); }
        if (data.status === "expired") return setState("error");
      } catch { return setState("error"); }
      if (++tries >= 10) return setState("error");
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, [params, refresh]);

  return (
    <Box id="payment-success-page">
      {state === "checking" && <p className="text-muted" data-testid="payment-checking">Estamos confirmando tu pago...</p>}
      {state === "paid" && (
        <>
          <h3 data-testid="payment-paid">{SUCCESS_TEXT}</h3>
          <p className="text-muted">Ya tienes todo el contenido abierto. Si tu plan incluye sesiones, te escribimos para acordarlas.</p>
          <Link to="/academia" className="btn btn-primary" style={{ marginTop: "1.4rem" }} data-testid="payment-go-academia">Seguir en Academia</Link>
        </>
      )}
      {state === "error" && (
        <>
          <p className="text-danger" data-testid="payment-error">{ERROR_TEXT}</p>
          <Link to="/planes" className="btn btn-primary" data-testid="payment-retry">Volver a los planes</Link>
        </>
      )}
    </Box>
  );
}

export function PaymentCancel() {
  return (
    <Box id="payment-cancel-page">
      <h3>No se ha hecho ningún cobro.</h3>
      <p className="text-muted">Puedes elegir un plan cuando quieras.</p>
      <Link to="/planes" className="btn btn-primary" style={{ marginTop: "1.2rem" }} data-testid="payment-cancel-back">Volver a los planes</Link>
    </Box>
  );
}

export function Privacidad() {
  return (
    <>
      <header className="wrap" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", height: 76 }}>
        <Brand /><ThemeToggle />
      </header>
      <main className="wrap" style={{ maxWidth: 760, paddingTop: "2rem" }} data-testid="privacy-page">
        <span className="eyebrow">Legal</span>
        <h1 className="hm-h1" style={{ marginTop: "1rem" }}>Aviso de privacidad</h1>
        <div className="card" style={{ marginTop: "2rem", fontSize: "1.05rem", lineHeight: 1.7 }} data-testid="privacy-text">
          Soy Heartmony. Guardo tu email, tu nombre y tu contraseña para darte acceso y enviarte la bienvenida. No comparto tus datos con terceros. Si quieres que los borre, escríbeme a:{" "}
          <a href="mailto:contacto@heartmony.es" className="text-accent font-semibold underline underline-offset-4" data-testid="privacy-contact-link">contacto@heartmony.es</a>.
        </div>
        <Link to="/" className="card-link" data-testid="privacy-back-link">Volver al inicio</Link>
      </main>
      <SiteFooter />
    </>
  );
}
